import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}`;

export const getDashboardStat = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}order/order/order-dashboard`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const findOneCategoriesProductByidProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/findOneCategoriesProductByidProduct/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

